import authService from "../auth/authService.js";
import axios from "../axios.js";
import { jwtDecode } from "jwt-decode";

const actions = {
    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////

    updateUserInfo({ commit }, payload) {
        commit("UPDATE_USER_INFO", payload);
    },

    setToken({ commit }, token) {
        commit("SET_TOKEN", token);

        // Set bearer token in axios
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    },
    setUser({ commit }, payload) {
        commit("SET_USER", payload);
    },

    async getUser({ commit }) {
        try {
            const { data: response } = await axios.get("/auth/user");
            commit("SET_USER", response.data);
            return response.data;
        } catch (error) {
            // auto logout if fetch user fails
            console.error("getUser error", error);
            commit("USER_LOGOUT");
        }
    },

    async login({ commit }, payload) {
        try {
            const { data: response } = await axios.post("/auth/login", payload);

            if (response.data) {
                commit("SET_USER", response.data);
            }

            return response;
        } catch (error) {
            throw error;
        }
    },

    async logout({ commit }) {
        try {
            const { data: response } = await axios.post("/auth/logout");
            commit("USER_LOGOUT");

            axios.defaults.headers.common["Authorization"] = null;

            return response;
        } catch (error) {
            throw error;
        }
    },

    async refreshToken({ commit }) {
        try {
            const { data: response } = await axios.post("/auth/refresh-token");
            return response;
        } catch (error) {
            throw error;
        }
    },

    clearUser({ commit }) {
        commit("USER_LOGOUT");
    },
};

export default actions;
